import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CreateButton from './CreateButton';

class CreateButtonContainer extends React.Component {
    render() {
        const { nextStepValid, isAdding, validationErrors, onSubmit, onClose, reclamation, autoriseSAV } = this.props;

        return (
            <CreateButton
                onSubmit={onSubmit}
                onClose={onClose}
                nextStepValid={nextStepValid}
                validationErrors={validationErrors}
                isAdding={isAdding}
                reclamation={reclamation}
                autoriseSAV={autoriseSAV} />
        );
    }
}

const mapStateToProps = state => ({
    isAdding: state.reclamation.reclamations.isAdding,
});


CreateButtonContainer.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    nextStepValid: PropTypes.bool.isRequired,
    validationErrors: PropTypes.array.isRequired,
    reclamation: PropTypes.object.isRequired,
    autoriseSAV: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, null)(CreateButtonContainer);